export const zIndex = {
    creator: 500,
    universalNavBar: 201,
    mainNavigation: 200,
    popover: 50,
    searchBar: 100,
};
